/* eslint-disable prettier/prettier */
let enumeratesFormater = {
    methods: {
        objectArrayToPlain(objectArray) {
            let plainArray = []
            objectArray.forEach(function (element) {
                plainArray.push(element.id)
            })
            return plainArray
        },
        formatFromList(list) {
            let self = this
            let ret = []
            list.forEach(function (elem) {
                ret.push({
                    id: elem.id,
                    title: elem.title != 'No tiene' ?
                        'Más de ' + parseInt(elem.title).toLocaleString('ES') + '€' : self.$t(elem.id)
                })
            })
            return ret
        },
        objectArrayToList(objectArray) {
            let plainArray = []
            let self = this
            objectArray.forEach(function (element) {
                plainArray.push({
                    id: element.id,
                    title: self.$t(element.id).replaceAll("#", " ")
                })
            })
            return plainArray
        },
        objectArrayToPlainDict(objectArray) {
            let self = this
            let plainArrayDict = {}
            objectArray.forEach(function (element) {
                plainArrayDict[element.id] = self.$t(element.id)
            })
            return plainArrayDict
        },
        formatWorldCountries(worldContries) {
            let countries = []
            let self = this
            worldContries.forEach(function (country) {
                countries.push({
                    id: country.id,
                    regions: country.regions,
                    title: self.$t(country.id).replaceAll("#", " ")
                })
            })
            return countries
        },
        formatMoneyRanges(ranges) {
            let formatedRanges = []
            ranges.forEach(function (range) {
                let rangeParts = range.title.split('-')
                formatedRanges.push({
                    id: range.id,
                    title: rangeParts.length > 1 ?
                        parseInt(rangeParts[0]).toLocaleString('ES') +
                        '€ - ' +
                        parseInt(rangeParts[1]).toLocaleString('ES') +
                        '€' : 'No tiene'
                })
            })
            return formatedRanges
        },
        tableDataToListFormat(data) {
            let listData = []
            data.forEach(function (col) {
                listData = listData.concat(col.rows)
            })
            return listData
        }
    }
}

export default enumeratesFormater